import { GLProgram } from '../../program.js';
export class DrawBrushProgram extends GLProgram {

    constructor(gl: any, vertex_source: any, fragment_source: any) {
        super(gl, vertex_source, fragment_source);
    }

    static create(templates, gl) {
        var common_source = templates.get('photoshop/GL/shaders/common.glsl');
        var vertex_source = templates.get('photoshop/GL/shaders/draw/brush/vertex.glsl');
        var fragment_source = templates.get('photoshop/GL/shaders/draw/brush/fragment.glsl');
        var result = new DrawBrushProgram(gl, common_source + vertex_source, common_source + fragment_source);
        result._uniforms['texture'] = gl.getUniformLocation(result._program, 'u_texture');
        result._uniforms['texture_size'] = gl.getUniformLocation(result._program, 'u_texture_size');
        result._uniforms['pan_inverse'] = gl.getUniformLocation(result._program, 'u_pan_inverse');
        result._uniforms['zoom_inverse'] = gl.getUniformLocation(result._program, 'u_zoom_inverse');
        result._uniforms['model_inverse'] = gl.getUniformLocation(result._program, 'u_model_inverse');
        result._uniforms['position'] = gl.getUniformLocation(result._program, 'u_position');
        result._uniforms['viewport'] = gl.getUniformLocation(result._program, 'u_viewport');
        result._uniforms['screen'] = gl.getUniformLocation(result._program, 'u_screen');
        result._uniforms['radius'] = gl.getUniformLocation(result._program, 'u_radius');
        return result;
    }

    setUniforms(parameters) {
        var self = this;
        self._gl.uniform2fv(self.uniformLocation('position'), parameters.position);
        self._gl.uniform2f(self.uniformLocation('viewport'), self._gl.canvas.width, self._gl.canvas.height);
        self._gl.uniform2f(self.uniformLocation('screen'), screen.width, screen.height);
        self._gl.uniform1f(self.uniformLocation('radius'), parameters.size / 2);
    }

}